import React, { useState } from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Alert from "@material-ui/lab/Alert";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { DropzoneArea } from "material-ui-dropzone";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import Tooltip from "@material-ui/core/Tooltip";
import InfoIcon from "@material-ui/icons/InfoOutlined";
import toBase64 from "../../utils/toBase64";
import {
  StyledActionCard,
  StyledCircleButton,
  StyledSelectedImage,
} from "./common.styles";

const UploadComponent = ({
  onSelect,
  label,
  NoteComponent,
  preselected,
  plainButton,
  onClose,
  onlyHorizontal,
  tooltipLabel,
}) => {
  const [error, setError] = useState(null);
  const [openDialog, setDialogOpen] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(preselected || null);

  const handleSave = async (files) => {
    const img = new Image();
    img.onload = () => {
      if (
        onlyHorizontal &&
        (img.width < img.height || img.width < 1024 || img.height < 768)
      ) {
        setError(
          "The image has incorrect dimensions. Please upload a landscape orientation image. Mininum required dimension is 1024x768. Only JPG and PNG formats are supported."
        );
        return;
      }

      setSelectedFile(files[0]);
      setDialogOpen(false);
      onSelect && onSelect(files[0]);
    };

    const imgBase64 = await toBase64(files[0]);
    img.src = imgBase64;
  };

  const handleClose = () => {
    setDialogOpen(false);
    onClose && onClose();
  };

  const handleDeleteFile = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpenDeleteModal(true);
  };

  const deleteFile = () => {
    setSelectedFile(null);
    setDialogOpen(false);
    onSelect && onSelect(null);
    setOpenDeleteModal(false);
  };

  return (
    <Box>
      {plainButton ? (
        <Box onClick={() => setDialogOpen(true)}>
          <Typography variant="subtitle2" color="primary">
            {label}
          </Typography>
        </Box>
      ) : (
        <StyledActionCard onClick={() => setDialogOpen(true)}>
          <Box display="flex" flexDirection="row" alignItems="center">
            <Typography variant="subtitle2">Upload {label}</Typography>
            {tooltipLabel ? (
              <Box display="flex" pl={"4px"}>
                <Tooltip title={tooltipLabel} arrow placement="top">
                  <InfoIcon style={{ fontSize: 12 }} />
                </Tooltip>
              </Box>
            ) : null}
            <Box flex="1" />
            {selectedFile ? (
              <StyledCircleButton onClick={handleDeleteFile}>
                <img src={require("../../assets/delete.png")} />
              </StyledCircleButton>
            ) : (
              <StyledCircleButton onClick={() => setDialogOpen(true)}>
                <img src={require("../../assets/add.png")} />
              </StyledCircleButton>
            )}
          </Box>
          {selectedFile && (
            <>
              <Box mt={1} />
              <StyledSelectedImage>
                <img src={`${URL.createObjectURL(selectedFile)}`} />
              </StyledSelectedImage>
              <Box mt={1} />
            </>
          )}
        </StyledActionCard>
      )}

      <Dialog open={openDialog} onClose={handleClose}>
        <DialogTitle disableTypography>
          <Typography variant="h6" component="h2">
            Upload {label}
          </Typography>
          <Box flex="1" />
          <StyledCircleButton onClick={handleClose}>
            <img src={require("../../assets/close.png")} />
          </StyledCircleButton>
        </DialogTitle>
        <DialogContent>
          {error && (
            <>
              <Alert severity="error">{error}</Alert>
              <Box mb={0.5} />
            </>
          )}
          <DropzoneArea
            showAlerts={false}
            showPreviewsInDropzone={false}
            onDrop={handleSave}
            acceptedFiles={["image/png", "image/jpg", "image/jpeg"]}
            showPreviews={false}
            maxFileSize={8000000}
            onClose={handleClose}
            dropzoneText={
              "Drag & Drop your image here, or click here to browse your files."
            }
          />
        </DialogContent>
        <DialogActions>
          <InfoOutlinedIcon />
          {NoteComponent || (
            <Typography variant="caption">
              Only <b>JPG</b> and <b>PNG</b> formats are supported.
            </Typography>
          )}
          <Box mr={1} flex="1" />
          <Button variant="contained" color="primary" disabled={!selectedFile}>
            Upload
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openDeleteModal} onClose={handleClose}>
        <DialogContent>
          <Box textAlign="center" mt={1} mb={1} pl={1} pr={1}>
            <StyledCircleButton onClick={handleDeleteFile} className="big">
              <img src={require("../../assets/delete.png")} />
            </StyledCircleButton>
            <Box mb={1} />
            <Typography variant="h6">Remove {label}</Typography>
            <Box mb={1} />
            <Typography variant="caption">
              Would you like to remove the uploaded file?
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Box flex="2" />
          <Button variant="contained" color="primary" onClick={deleteFile}>
            Yes
          </Button>
          <Box flex="1" />
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setOpenDeleteModal(false)}
          >
            No
          </Button>
          <Box flex="2" />
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default UploadComponent;
